import React from "react"
import PropTypes from "prop-types"

import ComponentError from "ui-ComponentError"

export const styleSheet = theme => ({
  container: {
    paddingLeft: theme.spacing.unit * 1,
    paddingRight: theme.spacing.unit * 1,

    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
})

function DialogError({
  classes,
  className: classNameProp,
  section,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.section]: section,
    },
    classNameProp
  )

  return (
    <ComponentError {...otherProps} className={className} containerClassName={classes.container} />
  )
}

DialogError.propTypes = {
  section: PropTypes.bool,
}

DialogError.Actions = require("ui-ComponentError/ComponentErrorActions").default
DialogError.Message = require("ui-ComponentError/ComponentErrorMessage").default

import classnames from "classnames"
import withStyles from "@material-ui/core/styles/withStyles"

export default withStyles(styleSheet)(DialogError)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/DialogError.js